import {
  getStats,
  getFinishedBackup
} from "@/services/api/app/box/stats";

const defaultState = () => ({
  stats: {},
  finishedBackup: false,
});

export default {
  namespaced: true,

  actions: {
    getStats({commit}, data) {
      return getStats(data)
        .then(stats => {
          commit('setStats', stats);
          return stats;
        })
    },
    getFinishedBackup({commit}) {
      return getFinishedBackup()
        .then(finishedBackup => {
          commit('setFinishedBackup', finishedBackup);
          return finishedBackup;
        })
    },
  },

  mutations: {
    setStats(state, stats) {
      state.stats = stats
    },
    setFinishedBackup(state, finishedBackup) {
      state.finishedBackup = finishedBackup
    },
  },

  getters: {
    getTotalProtectedData: (state) => () => {
      const
        driveStats = state.stats?.driveStats?.totalData || 0,

        totalData = driveStats

      return totalData
    },
  },

  state: defaultState(),
}
